/*
 * This code was generated with assistance from GitHub Copilot.
 * De-bundled from react-dxd-components@0.1.33 compiled dist/index.js (webpack module id 2).
 *
 * Vendored, simplified port of the `classnames` package
 * (Copyright (c) 2016 Jed Watson, MIT License, http://jedwatson.github.io/classnames)
 */

export interface ClassDictionary {
  [id: string]: unknown;
}

export type ClassValue = string | number | ClassDictionary | ClassValue[] | null | undefined | false;

export function classNames(...args: ClassValue[]): string {
  const classes: string[] = [];

  for (const arg of args) {
    if (!arg) continue;

    const argType = typeof arg;

    if (argType === 'string' || argType === 'number') {
      classes.push(String(arg));
    } else if (Array.isArray(arg)) {
      const inner = classNames(...arg);
      if (inner) classes.push(inner);
    } else if (argType === 'object') {
      for (const key in arg as ClassDictionary) {
        if (Object.prototype.hasOwnProperty.call(arg, key) && (arg as ClassDictionary)[key]) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(' ');
}

export default classNames;

